import { createModel } from '@rematch/core'
import * as firebase from 'firebase'

type IState = IPromotion[]

export default createModel({
  state: {} as IState,
  reducers: {
    updatePromotions: (state: IState, promotions: IPromotion[]): IState => promotions,
  },
  effects: {
    async fetchPromotions() {
      const ref = await firebase.firestore().collection('promotions').get()
      const promotions = ref.docs.map(doc => doc.data() as IPromotion)
      this.updatePromotions(promotions)
    },
  },
  selectors: {
  }
})


// WEBPACK FOOTER //
// ./src/models/promotions.ts